import 'swag-client-common/utils/change-public-path/change-public-path';
import React, { useEffect } from 'react';
import classnames from 'classnames';
import { SnackbarProvider } from 'notistack';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { MuiThemeProvider as V0MuiThemeProvider } from 'material-ui/styles';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { Snackbar } from 'swag-client-common/components/ui/snackbar';
import snackbarClasses from 'swag-client-common/components/ui/snackbar/snackbar.scss';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import './reset.scss';
import './normalize.scss';
import classes from './root.scss';
import { styles, v0Styles } from './themes';
export const theme = createMuiTheme(styles);
const themeV0 = getMuiTheme({}, v0Styles);
const Root = ({
  children,
  isProductPage,
  isLoggedIn,
  onWindowFocus
}) => {
  var _children$props;
  const routes = children === null || children === void 0 ? void 0 : (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.routes;
  const onFocus = () => {
    if (isLoggedIn) {
      onWindowFocus();
    }
  };
  useEffect(() => {
    window.addEventListener('focus', onFocus);
    return () => {
      window.removeEventListener('focus', onFocus);
    };
  });
  let bgGrey = false;
  let staticPage = false;
  if (routes && routes[1].path && routes[1].path.indexOf('pages') > -1) {
    staticPage = true;
  }
  const pathWithSlash = routes && routes[1].path && `/${routes[1].path}`;
  switch (pathWithSlash) {
    case APP_ROUTES.MY_COMPANY:
    case `${APP_ROUTES.IN_A_BOX}/list`:
    case APP_ROUTES.ACCOUNT_PROFILE:
      bgGrey = true;
      break;
    case undefined:
    case '/pages':
    case APP_ROUTES.KICKSTARTER:
      staticPage = true;
      break;
    default:
      break;
  }
  const rootClasses = classnames(classes.root, {
    [classes['bg-grey']]: !!bgGrey,
    [classes['static-page']]: !!staticPage,
    [classes.productPage]: isProductPage
  });
  return /*#__PURE__*/React.createElement("div", {
    id: "main",
    className: rootClasses
  }, /*#__PURE__*/React.createElement(MuiThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(V0MuiThemeProvider, {
    muiTheme: themeV0
  }, /*#__PURE__*/React.createElement(SnackbarProvider, {
    classes: {
      variantError: snackbarClasses.error,
      variantWarning: snackbarClasses.warning
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, children), /*#__PURE__*/React.createElement(Snackbar, null))))));
};
export default Root;